import React from 'react';

import {ObjectsSection} from './components/ObjectsSection';

interface DatasetsSectionProps {
  entityName: string;
  projectName: string;
}

export const DatasetsSection: React.FC<DatasetsSectionProps> = ({
  entityName,
  projectName,
}) => {
  return (
    <ObjectsSection
      entityName={entityName}
      projectName={projectName}
      objectClass="Dataset"
      title="Datasets"
      viewAllPath="datasets"
      emptyMessage="No datasets yet"
      emptySubtitle="Datasets you create will appear here"
      emptyIcon="table"
      emptyIconColor="text-blue-500"
      emptyIconBgGradient="from-blue-50 to-blue-100"
    />
  );
};
